/**
 * The header and cta name of the express interest form
 - JOIN_WAITLIST: "Join Waitlist"
 - EXPRESS_INTEREST: "Express Interest"
 */
export const EXPRESS_INTEREST_SUBMIT_BTN_TEXTS = {
    JOIN_WAITLIST: "Join Waitlist",
    EXPRESS_INTEREST: "Express Interest",
};
